export const CAMPAIGN_CLASSES = ['Rebaixa', 'Lista Sugerida', 'A+B', 'Cupom'];

export const BUSINESS_UNITS = [{value:'NT', label:'Foods'}, 'BW', 'HC', 'PC', 'Outros'];

export const REGIONS = ['Centro-Norte', 'Centro-Oeste', 'Leste', 'Nordeste', 'Norte', 'Sudeste', 'Sul', 'São Paulo'];